import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewChild,
  AfterViewInit,
} from '@angular/core';

import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

import { TableColumn } from '../table.types';
import { TableService } from '../table.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TableConfig } from '../table.config';
import { parseChipArray, estimateChipWidth } from '../table.utils';
import { AuthenticationService } from '@app/services/auth.service';
import { Role } from '@app/services/Roles/roleEnum';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent<T> implements AfterViewInit {
  // @Input() records: T[] = [];

  private _records: any[] = [];

  @Input()
  set records(value: any[]) {
    this._records = value;
    this.onRecordsChange(value);
  }

  get records() {
    return this._records;
  }

  onRecordsChange(updatedRecords: any[]) {
    let records = this.mapTableData(updatedRecords);
    this.dataSource = new MatTableDataSource(records);
  }

  @Input() columns: any[] = [];
  @Input() loading = false;
  @Input() title = '';
  @Input() totalRecords = 0;

  @Input() enableSelection = false;
  @Input() multiSelect = false;
  selected: T[] = [];

  @Input() showFilter = true;
  @Input() showExport = true;

  @Output() rowClick = new EventEmitter<T>();
  @Output() selectionChange = new EventEmitter<T[]>();
  @Output() onPageChange = new EventEmitter<any>();

  dataSource = new MatTableDataSource<T>([]);

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  currentUser: any = {};
  isAdmin: boolean = true;
  isLinkActive: boolean = false;

  constructor(
    private svc: TableService,
    private sanitizer: DomSanitizer,
    public config: TableConfig,
    private authService: AuthenticationService
  ) {}

  get checkLinkActive() {
    this.currentUser = this.authService.getCurrentUser();
    this.isAdmin = this.currentUser.roles.includes(3);
    this.isLinkActive = [
      Role.Admin,
      Role.Pharmacist,
      Role.PharmacyManager,
    ].some((role) => this.currentUser.roles.includes(role));
    return this.isLinkActive;
  }

  getValueByPath(obj: any, path: string): any {
    return path.split('.').reduce((acc: any, key: string) => {
      return acc && acc[key] !== undefined ? acc[key] : null;
    }, obj);
  }

  mapTableData(apiData: any[]) {
    return apiData.map((row: any) => {
      const formattedRow: any = {};
      formattedRow['id'] = row.sale.id || '';

      this.columns.forEach((col) => {
        formattedRow[col.key] = '';
        if (col.valuePath) {
          formattedRow[col.key] = this.getValueByPath(row, col.valuePath);
        }

        if (col.otherObjectKeysArray) {
          col.otherObjectKeysArray.forEach((element: any) => {
            formattedRow[element.key] = this.getValueByPath(
              row,
              element.refKey
            );
          });
        }

        if (col.type === 'link') {
          col.type = this.checkLinkActive ? 'link' : 'text';
        }
      });

      const updateFormated = structuredClone(formattedRow);

      return updateFormated;
    });
  }

  ngAfterViewInit() {
    // // this.records = this.mapTableData(this.records);
    // this.dataSource = new MatTableDataSource(this.records);
    // this.dataSource.sort = this.sort;
    // this.dataSource.paginator = this.paginator;
  }

  get displayedColumns(): string[] {
    const cols = this.columns
      .filter((c) => c.visible)
      .map((c) => c.key as string);
    return this.enableSelection ? ['select', ...cols] : cols;
  }

  onSelect(row: T, checked: boolean) {
    if (this.multiSelect) {
      checked
        ? this.selected.push(row)
        : (this.selected = this.selected.filter((x) => x !== row));
    } else {
      this.selected = checked ? [row] : [];
    }
    this.selectionChange.emit(this.selected);
  }

  export(format: 'csv') {
    this.svc.exportCSV('table_export', this.records);
  }

  sanitize(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getChips(row: T, col: TableColumn<T>) {
    return parseChipArray(row[col.key as keyof T]);
  }
  selectAllRows(checked: boolean) {
    if (checked) {
      this.dataSource.data.forEach((row) => {
        this.onSelect(row, true);
      });
    } else {
      this.selected = [];
    }
  }
  getTooltip(element: HTMLElement): string {
    // Check if the content is overflowing
    if (element.scrollWidth > element.clientWidth) {
      return element.innerText || element.textContent || '';
    } else {
      return ''; // No tooltip if content is not overflowing
    }
  }

  getValue(object: any, key: any) {
    return object[key];
  }
}
